import type { MatchedCoach } from '@/modules/api';

/**
 * The coach's name line: the provider's `displayName` when present, otherwise
 * the `firstName`. Unlike `coachDisplayName`, the title is NOT appended — it's
 * meant to be shown on its own line beneath the name (e.g. "Coach Brian" over
 * "Coach"). Returns '' when neither is set.
 */
export function coachName(coach: Pick<MatchedCoach, 'displayName' | 'firstName'>): string {
  return coach.displayName?.trim() || coach.firstName?.trim() || '';
}
